import React from 'react';

import classes from './Backdrop.module.css';

const Backdrop = (props) => {
    let styleClasses = [classes.Backdrop, classes.Close];

    if (props.visible) {
        styleClasses = [classes.Backdrop, classes.Open];
        // document.body.style.overflowY = 'hidden';
    } else {
        // document.body.style.overflowY = 'unset';
    }

    if(props.backdropClicked !== undefined) {
        styleClasses.push(classes.Clickable);
    }

    if(props.transparent !== undefined && props.transparent) {
        styleClasses.push(classes.Transparent);
    }
    const zIndex = props.zIndex !== undefined ? props.zIndex : 100;

    return props.visible ? <div className={styleClasses.join(' ')} style={{zIndex: zIndex}} onClick={props.backdropClicked}></div> : null;
}

export default Backdrop;